import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { useLocation } from "react-router-dom";
import { SharedButton } from "../../../../../sharedComponents/Button";
import moment from "moment";
import { NewDateRange } from "../../../../../sharedComponents/NewDateRange";
import { DatePicker } from "antd"



export const DiscountTrDetailReport = () => {
    const location = useLocation();
    const [loader, setLoader] = useState(false);

    const [trData, setTrData] = useState([]);
    const [fullAm, setFullAm] = useState();

    const [originalData, setOriginalData] = useState([]);

    const { RangePicker } = DatePicker;

    const getReport = async (data) => {
        setLoader(true);
        let array = [];

        let Initial_Cost = 0;
        let Discount_Amount = 0;
        let Total_After_Discount_Amount = 0;
        let Tax1 = 0;
        let Tax2 = 0;
        let full_amount = 0;


        if (data && data.length > 0) {
            (data ?? []).forEach(e => {

                let resetInCost = 0;
                let resetDiscountAmount = 0;
                let resetTotalAfterDiscountAmount = 0;
                let resetTax1 = 0;
                let resetTax2 = 0;
                let fnl = 0;

                let after_discount = parseFloat(e.finalBaseAmount) - parseFloat(e.discount);


                resetInCost = parseFloat(e.finalBaseAmount);
                resetDiscountAmount = parseFloat(e.discount);
                resetTotalAfterDiscountAmount = parseFloat(after_discount);
                resetTax1 = parseFloat(e.finalTax1);
                resetTax2 = parseFloat(e.finalTax2);
                fnl = parseFloat(e.finalSubTotal);


                Initial_Cost += parseFloat(resetInCost);
                Discount_Amount += parseFloat(resetDiscountAmount);
                Total_After_Discount_Amount += parseFloat(resetTotalAfterDiscountAmount);
                Tax1 += parseFloat(resetTax1);
                Tax2 += parseFloat(resetTax2);
                full_amount += parseFloat(fnl);

                array.push({
                    subtotal: parseFloat(fnl).toFixed(2),
                    datetime: moment.unix(e.create_dt).format('DD-MMM-YYYY'),
                    client: e.name + ' ' + e.lastname,
                    method: "Credit/Debit",
                    discount_code_name: e.discount_code_name,
                    item: e.item_name,
                    finalBaseAmount: "$ " + parseFloat(e.finalBaseAmount).toFixed(2),
                    discount: "- $ " + parseFloat(e.discount).toFixed(2),
                    after_discount: "$ " + parseFloat(after_discount).toFixed(2),
                    finalTax1: "$ " + parseFloat(e.finalTax1).toFixed(2),
                    finalTax2: "$ " + parseFloat(e.finalTax2).toFixed(2),
                    finalAdjustPrice: "$ " + parseFloat(e.finalAdjustPrice).toFixed(2),
                    amount: "$ " + parseFloat(fnl).toFixed(2) || 0,
                })
            });
            setTrData(array);
            setFullAm({
                Initial_Cost: parseFloat(Initial_Cost).toFixed(2),
                Discount_Amount: parseFloat(Discount_Amount).toFixed(2),
                Total_After_Discount_Amount: parseFloat(Total_After_Discount_Amount).toFixed(2),
                Tax1: parseFloat(Tax1).toFixed(2),
                Tax2: parseFloat(Tax2).toFixed(2),
                full_amount: parseFloat(full_amount).toFixed(2),
            });
            setLoader(false);
        } else {
            setTrData([]);
        }
        setLoader(false);
    }


    const exportToCSV = () => {
        if (!trData || trData.length === 0) {
            return;
        }

        const headers = [
            "Date",
            "Client Name",
            "Method",
            "Discount Code",
            "Item",
            "Initial Cost",
            "Discount Amount",
            "Sub Total After Discount",
            "Tax 1",
            "Tax 2",
            "Total Fee Charged"
        ];

        const rows = trData.map((row) => [
            row.datetime,
            row.client,
            row.method,
            row.discount_code_name || "",
            row.item || "",
            row.finalBaseAmount,
            row.discount,
            row.after_discount,
            row.finalTax1,
            row.finalTax2,
            row.amount
        ]);

        const csvContent = [
            headers,
            ...rows
        ]
            .map((row) =>
                row
                    .map((value) => `"${String(value ?? "").replace(/"/g, '""')}"`)
                    .join(",")
            )
            .join("\n");

        const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;"
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `discount_code_transaction_report_${moment().format("YYYY-MM-DD")}.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };


    useEffect(() => {
        if (location && location.state) {
            setOriginalData(location.state);
            getReport(location.state)
        }
    }, [location.state])


    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [selectedDate, setSelectedDate] = useState();
    const [dvalue, setDvalue] = useState();


    const filterByDate = () => {
        if (!startDate || !endDate) {
            getReport(originalData);
            return;
        }

        const filtered = originalData.filter((item) => {
            const itemDate = moment.unix(item.create_dt).startOf('day');
            return itemDate.isBetween(
                moment(startDate).startOf('day'),
                moment(endDate).endOf('day'),
                null,
                '[]' // include both dates
            );
        });

        getReport(filtered);
    };

    useEffect(() => {
        if (startDate && endDate) {
            filterByDate();
        }
    }, [startDate, endDate]);



    const handleDateChange = (value) => {
        setDvalue(value);
        if (value && value.length === 2) {
            const formattedStartDate = moment(value[0].$d).format("YYYY-MM-DD");
            const formattedEndDate = moment(value[1].$d).format("YYYY-MM-DD");
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
        } else {
            setStartDate(null);
            setEndDate(null);
        }
    };


    return (
        <>
            {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> </Spinner> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <div style={{ marginLeft: '8rem' }}>
                                    <HeaderDashboard />
                                </div>
                                <section className="addClient innerContent">
                                    <div className="AddClientContent" style={{ marginLeft: '8rem' }}>
                                        <Container>
                                            <h4 className="mb-4">Discount Code Transaction Detail Report</h4>
                                            <Row>
                                                <Col>
                                                    <div className="daterange_parent d-flex" style={{ justifyContent: 'space-between' }}>
                                                        <div className="daterange_parent">
                                                            <RangePicker
                                                                value={dvalue}
                                                                format="DD-MM-YYYY"
                                                                onChange={handleDateChange}
                                                            />
                                                        </div>


                                                    </div>
                                                </Col>
                                                <Col className="text-right">
                                                    <SharedButton
                                                        title={"Export to CSV"}
                                                        className={"backBtn mr-2"}
                                                        type={"button"}
                                                        onClick={exportToCSV}
                                                        disabled={!trData || trData.length === 0}
                                                    />
                                                    <SharedButton
                                                        title={"Reset"}
                                                        className={"backBtn mr-2"}
                                                        type={"button"}
                                                        onClick={() => {
                                                            setDvalue();
                                                            setStartDate(null);
                                                            setEndDate(null);
                                                            getReport(originalData);
                                                        }}
                                                    />
                                                    <SharedButton
                                                        title={"Back"}
                                                        className={"backBtn"}
                                                        type={"button"}
                                                        onClick={() => {
                                                            window.history.back();
                                                        }}
                                                    />
                                                </Col></Row>
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <div className="row transactionReport w-100">
                                                        <div style={{ overflowX: 'auto', }}>
                                                            <table className="table table-striped table-bordered" style={{ whiteSpace: 'nowrap' }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Date/Time</th>
                                                                        <th>Client Name</th>
                                                                        <th>Method</th>
                                                                        <th>DiscountCode</th>
                                                                        <th>Item</th>
                                                                        <th>Initial Cost</th>
                                                                        <th>Discount Amount</th>
                                                                        <th>Sub Total After Discount</th>
                                                                        <th>Tax 1</th>
                                                                        <th>Tax 2</th>
                                                                        <th>Total Fee Charged</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ fontSize: '14px' }}>
                                                                    {trData && trData.length > 0 && trData.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{row.datetime}</td>
                                                                            <td>{row.client}</td>
                                                                            <td>{row.method}</td>
                                                                            <td>{row.discount_code_name}</td>
                                                                            <td>{row.item}</td>
                                                                            <td>{row.finalBaseAmount}</td>
                                                                            <td>{row.discount}</td>
                                                                            <td>{row.after_discount}</td>
                                                                            <td>{row.finalTax1}</td>
                                                                            <td>{row.finalTax2}</td>
                                                                            <td>{row.amount}</td>
                                                                        </tr>
                                                                    ))}

                                                                    {trData && trData.length > 0 && (
                                                                        <tr className='highlighted highlighted-my'>
                                                                            <td>Total</td>
                                                                            <td colSpan="4"></td>
                                                                            <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>$ {fullAm?.Initial_Cost}</td>
                                                                            <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>- $ {fullAm?.Discount_Amount}</td>
                                                                            <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>$ {fullAm?.Total_After_Discount_Amount}</td>
                                                                            <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>$ {fullAm?.Tax1}</td>
                                                                            <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>$ {fullAm?.Tax2}</td>
                                                                            <td colSpan="2" style={{ whiteSpace: 'nowrap' }}>$ {fullAm?.full_amount}</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {trData && trData.length <= 0 && (
                                                            <p className="text-center mt-4">No Data Available</p>
                                                        )}

                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};
